import { EqualisationFormValues } from '../FormWrapper';
import { sumBy } from 'lodash';
import { ActionRef } from 'further-types/lp/action';

const validateActionAllocations = (action: {
  newAllocations: Array<{
    excludeFromAllocation: boolean;
    allocationAmountLcy: number;
  }>;
  totalAmountLcy: number;
}) => {
  const includedAllocations = action.newAllocations.filter(
    (item) => !item.excludeFromAllocation,
  );

  const totalAllocationAmountLcy = sumBy(includedAllocations, (item) =>
    Number(item.allocationAmountLcy),
  );

  return Math.abs(totalAllocationAmountLcy - action.totalAmountLcy) < 0.01;
};

const validateRealisationActionAllocations = (
  action: EqualisationFormValues['actions'][number]['linkedActions'][number],
) => {
  const includedAllocations =
    action.newRealisationAllocations?.filter(
      (item) => !item.excludeFromAllocation,
    ) ?? [];
  const linkedTotalAllocationPercentage = sumBy(includedAllocations, (item) =>
    Number(item.allocationPercentage),
  );
  const allWithholdingTaxExempt = includedAllocations.every(
    (item) => item.withholdingTaxExempt,
  );
  return (
    Math.abs(linkedTotalAllocationPercentage - 100) < 0.01 &&
    !allWithholdingTaxExempt
  );
};

const allocationsAreValid = (
  action: EqualisationFormValues['actions'][number],
) => {
  const mainActionIsValid = validateActionAllocations(action);

  if (!mainActionIsValid) {
    return false;
  }

  for (const linkedAction of action.linkedActions) {
    const linkedActionIsValid =
      linkedAction.actionRef === ActionRef.Realisation
        ? validateRealisationActionAllocations(linkedAction)
        : validateActionAllocations(linkedAction);
    if (!linkedActionIsValid) {
      return false;
    }
  }

  return true;
};

export default allocationsAreValid;
